module.exports = __webpack_public_path__ + "static/img/google-play-badge-pt.2c82021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play-badge-pt.png
// module id = ANZw
// module chunks = 1